<fgb-page-header
  [backButtonLink]="'/games'"
  [pageTitle]="'games.page.predictor'"
  [showFooter]="false"
  [showBanner]="false"
></fgb-page-header>
<!--Banner-->
<fgb-portal-games-banner [isPredictorPage]="true"></fgb-portal-games-banner>
<!--Nav-->
<div class="mb-3">
  <router-outlet></router-outlet>
</div>
